import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

import { useSelector } from 'react-redux';
import {
  selectAttributeInfo,
  selectDateRange,
} from '../../../store/options/options.selector';
import { selectAltHurricanes } from '../../../store/alternate-data/alternate-data.selector';

import MarkdownToJsx from '../../markdown-to-jsx/markdown-to-jsx.component';


export default function HurricaneText({ place }) {
  const dateRange = useSelector(selectDateRange);
  const data = useSelector(selectAltHurricanes);
  const attrInfo = useSelector(selectAttributeInfo);
  const attrName = attrInfo.name;

  const count = data.reduce((sum, yearArr) => sum += yearArr.length, 0);

  const eventPlurality = count === 1 ? 'event' : 'events';
  let text = `In ${place}, data on past ${attrName.toLowerCase()} episodes show that ${place} reported experiencing ${count} ${attrName.toLowerCase()} ${eventPlurality} between ${
    dateRange.start
  } and ${dateRange.end}.`;

  const mdPath = [process.env.PUBLIC_URL, 'markdown', 'hazard_definitions'].join('/');
  const filename = attrName.toLowerCase().split(' ').join('_').replace('-','_').replace('/','_');

  return (
    <>
      <Typography>{text}</Typography>

      <div>
        <MarkdownToJsx path={`${mdPath}/${filename}.md`} />
        <hr style={{ width: '90%', margin: '4px auto 8px auto' }}></hr>
        <MarkdownToJsx path={`${mdPath}/definition_citation.md`} />
      </div>

      <div style={{ borderTop: '1px solid rgb(240,240,240)' }}>
        <MarkdownToJsx path={`${mdPath}/hurricane_api_source.md`} />
      </div>
    </>
  );
}

HurricaneText.propTypes = {
  place: PropTypes.string,
};
